module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Snowfall-S2.92db6c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Snowfall-S2.jpg
// module id = t6tn
// module chunks = 0